/**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2018 Photon Storm Ltd.
 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
 */

/**
 * @namespace Phaser.Create.Palettes
 */

module.exports = {

    ARNE16: require('./Arne16'),
    C64: require('./C64'),
    CGA: require('./CGA'),
    JMP: require('./JMP'),
    MSX: require('./MSX')
    
};



//////////////////
// WEBPACK FOOTER
// ./create/palettes/index.js
// module id = 478
// module chunks = 0